//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'monthSelect',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit('change', this.monthFormatFun(this.monthTime));
  },
  props: {
    width: {
      type: String,
      default: '300px'
    }
  },
  methods: {
    // 月份变化
    onMonthChange: function onMonthChange(date, dateString) {
      this.monthTime = date;
      this.$emit('change', this.monthFormatFun(this.monthTime));
    }
  }
};